















import { computed, defineComponent } from "@vue/composition-api";
import { AppDataEnabledFeatureNames } from "@/types/appDataEnabledFeatures.type";
import { useApps } from "@/composables/useApps";

export default defineComponent({
    props: {
        phoneNumber: {
            type: String,
            required: false,
        },
        displayNumber: {
            type: String,
            required: false,
        },
        noIcon: {
            type: Boolean,
            required: false,
        },
    },
    setup() {
        const { getEnabledFeature } = useApps();

        const clickablePhoneNumbersFeature = computed(() =>
            getEnabledFeature(AppDataEnabledFeatureNames.CLICKABLE_PHONE_NUMBERS)
        );
        const getParsedHref = (hrefPattern: string, number: string) => hrefPattern.replaceAll("{number}", number);

        return {
            clickablePhoneNumbersFeature,
            getParsedHref,
        };
    },
});
